import banner from "../../assets/images/banner/Rectangle2.jpg";
import banner1 from "../../assets/images/banner/Rectangle3.jpg";
import banner2 from "../../assets/images/banner/Rectangle4.jpg";

const data = [banner, banner1, banner2];

export default data;